var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('svg', {
    attrs: {
      "width": "12",
      "height": "7",
      "viewBox": "0 0 12 7",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    staticClass: "fill-current",
    attrs: {
      "d": "M1.28033 0.21967C0.987436 -0.0732233 0.512564 -0.0732233 0.21967 0.21967C-0.0732231 0.512563 -0.0732231 0.987437 0.21967 1.28033L5.21967 6.28033C5.51256 6.57322 5.98744 6.57322 6.28033 6.28033L11.2803 1.28033C11.5732 0.987437 11.5732 0.512563 11.2803 0.21967C10.9874 -0.0732233 10.5126 -0.0732233 10.2197 0.21967L5.75 4.68934L1.28033 0.21967Z",
      "stroke": "none"
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };